import { useLocation } from 'react-router-dom';

function useQuery() {
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const queryOrderId = queryParams.get('oUuid') || '';
  const queryTrackUrl = queryParams.get('tr') || '';
  const queryBusinessId = queryParams.get('bid') || '';
  const queryOcoExternalId = queryParams.get('oco_external_id') || '';
  const queryBusinessUuid = queryParams.get('bUuid') || '';
  return {
    queryOrderId,
    queryTrackUrl,
    queryBusinessId,
    queryOcoExternalId,
    queryBusinessUuid
  }
}

export default useQuery;